import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CarouselSwiperConsultaComponent } from './carousel-swiper-consulta.component';


@NgModule({
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    CarouselSwiperConsultaComponent
  ],
  providers: [
  ],
  declarations: [
    CarouselSwiperConsultaComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CarouselSwiperConsultaModule { }
